<div class="body">

    <span class="material-icons closeButton" (click)="clickCloseButton()">
        close
    </span>
    <div class="header">
        <div class="icon">
            <img src="../../../../assets/images/sugestion-modal/percentage-icon.gif" alt="Ícone de porcentagem">
        </div>
        <div class="title">
            <h2>Economize mais com outro pacote de crédito!</h2>
        </div>
    </div>


    <div class="content mlmr">
        <p>
            <span *ngIf="sameProduct"><b>Você já adquiriu este produto anteriormente</b> e temos uma recomendação para
                você:</span>
            <span *ngIf="!sameProduct"><b>Temos uma recomendação para você:</b></span>
            um pacote de créditos com <b>valores mais vantajosos</b> para aproveitar ao máximo nossas soluções.
        </p>
    </div>

    <div class="content sugestion">
        <div class="abstract" >
            <div class="collumn">
                <ng-container *ngIf="fullQuery || mediumQuery">
                <p>Faça até</p>
                <ul>
                    <li *ngIf="fullQuery"><img src="../../../../assets/images/sugestion-modal/checked.svg" alt=""> {{fullQuery}} consultas
                        completas </li>
                    <li *ngIf="mediumQuery"><img src="../../../../assets/images/sugestion-modal/credit_report.svg" alt="">ou {{mediumQuery}}
                        consultas intermediárias</li>
                </ul>
                </ng-container>
            </div>
            <div class="collumn">
                <ul>
                    <li class="oldValue" *ngIf="showFullValue">De <span class="value">R$ {{fullValueStr}}</span> por</li>
                    <li class="newValue"><b>R$ {{discountedValueStr}}</b> </li>
                </ul>
            </div>
        </div>

        <div class="center">
            <button class="showDetails" (click)="setColapser()">Confira todas as soluções aqui<img
                    src="/assets/images/icons-stepper/chevron_right.svg"
                    [ngClass]="{'down':colapsed,'up': !colapsed}"></button>
        </div>

        <div class="details center" class="display-utils-hide-lt-sm" *ngIf="!colapsed">
            <table>
                <colgroup>
                    <col span="1">
                    <col span="1">
                    <col span="2" class="highlightCollumn">
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>Pacote atual<br>R$ {{currentvalueStr}}</th>
                        <th colspan="2" class="upBorderRadius"><b>R$ {{fullValueStr}}</b></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngFor="let feature of features; let i = index; let isFirst = first; let isLast = last">
                        <tr>
                            <td>{{ feature.name }}</td>
                            <td class="centerCell">{{ feature.current }}</td>
                            <td class="centerCell" [ngClass]="{ 'downBorderRadiusLeft': isLast }">{{ feature.new }}</td>
                            <td [attr.rowspan]="this.features.length" class="verticalText downBorderRadiusRight"
                                *ngIf="isFirst"><b>Mais
                                    benefícios para você!</b></td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <div class="details" class="display-utils-only-lt-sm" *ngIf="!colapsed">
            <table>
                <colgroup>
                    <col span="1">
                    <col span="1">
                    <col span="2" class="highlightCollumn">
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>Pacote atual<br>R$ {{currentvalueStr}}</th>
                        <th colspan="2" class="upBorderRadius"><b>R$ {{fullValueStr}}</b></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let feature of features; let i = index; let isFirst = first; let isLast = last">
                        <tr>
                            <td>{{ feature.name }}</td>
                            <td class="centerCell">{{ feature.current }}</td>
                            <td class="centerCell" [ngClass]="{ 'downBorderRadiusLeft': isLast }">{{ feature.new }}</td>
                            <td [attr.rowspan]="this.features.length" class="verticalText downBorderRadiusRight"
                                *ngIf="isFirst"><b>Mais
                                    benefícios para você!</b></td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>

    <!-- <div class="promo-banner">
        <div class="row">
            <img src="../../../../assets/images/sugestion-modal/gift.svg" alt="">
            <p>
                
                    Somente hoje na compra do pacote de R$ {{fullValue}} <br>
                <strong>
                    ganhe {{discountPercent}}% de desconto!
                </strong>
            </p>
        </div>

    </div><br> -->

    <div *ngIf="discountIdentifier" class="countdown-banner">
        <p>
          Aproveite essa oferta especial: <strong>{{discountPercent}}% OFF</strong>
        </p>
        <div class="countdown-timer">
          <div class="time-box">
            <span id="minute-tens">0</span>
          </div>
          <div class="time-box">
            <span id="minute-units">0</span>
          </div>
          <span class="separator">:</span>
          <div class="time-box">
            <span id="second-tens">0</span>
          </div>
          <div class="time-box">
            <span id="second-units">0</span>
          </div>
        </div>
        <div class="labels">
          <div class="time-label">
            <span>MINUTOS</span>
          </div>
          <div class="time-label">
            <span>SEGUNDOS</span>
          </div>
        </div>
      </div>

    <div class="content" class="display-utils-hide-lt-md">
        <div class="center">
            <button class="btn-product" (click)="clickCurrentButton()">
                <p>Continuar com R$ {{currentvalueStr}}</p>
            </button>
            <button class="btn-product btn-sugestion" (click)="clickUpButton()">
                <p>Alterar para R$ {{discountValueStr}}</p>
            </button>
        </div>
    </div>
    <div class="content" class="display-utils-only-lt-md">
        <button class="btn-product mobile" (click)="clickCurrentButton()">
            <p>Continuar com R$ {{currentvalueStr}}</p>
        </button>
        <br>
        <button class="btn-product btn-sugestion mobile" (click)="clickUpButton()">
            <p>Alterar para R$ {{discountValueStr}}</p>
        </button>
    </div>
</div>